/* eslint-disable no-case-declarations */
import { Action } from "redux";
import { validateProcessVariableValue } from "../../processEditor/actions/ValidateProcessVariables";

import * as ProcessVariableEditorActions from '../actions/ProcessVariablesEditorActions';
import { ProcessVariablesEditorState } from "../model/ProcessVariablesEditorState";
import { getProcessVariableDisplayValue, getProcessVariableValue } from "../../processEditor/reducers/ProcessVariablesReducer";

export function processVariablesEditorState(state: ProcessVariablesEditorState = new ProcessVariablesEditorState(), action: Action): ProcessVariablesEditorState {
    switch (action.type) {
        case ProcessVariableEditorActions.RECEIVE_PROCESS_VARIABLES:
            const receiveProcessVariablesAction = action as ProcessVariableEditorActions.ReceiveProcessVariablesAction

            return {
                processVariables: receiveProcessVariablesAction.processVariables.map((processVariable, id) => {
                    const mode = processVariable.mode ?? 'json';
                    return {
                        ...processVariable,
                        id: id,
                        originalValue: processVariable.value,
                        displayValue: getProcessVariableDisplayValue(processVariable.value, mode),
                        validationErrors: [],
                        isMasked: processVariable.isSecret,
                        mode: mode,
                        description: processVariable.description ?? '',
                    }}),
                isDirty: false,
            } as ProcessVariablesEditorState;

        case ProcessVariableEditorActions.UPDATE_PROCESS_VARIABLE_VALUE_DRAFT:
            const updateProcessVariableValueDraftAction = action as ProcessVariableEditorActions.UpdateProcessVariableValueDraftAction;

            const updatedVariables = state.processVariables.map((processVariable) => {
                if (processVariable.id != updateProcessVariableValueDraftAction.id) {
                    return processVariable;
                }

                processVariable.displayValue = updateProcessVariableValueDraftAction.newDisplayValue;
                processVariable.value = getProcessVariableValue(updateProcessVariableValueDraftAction.newDisplayValue, processVariable.mode);
                processVariable.validationErrors = validateProcessVariableValue(processVariable, updateProcessVariableValueDraftAction.environmentVariables)

                return processVariable;
            });

            const isDirty = updatedVariables.some(processVariables => processVariables.value != processVariables.originalValue);

            return Object.assign({}, state, {
                processVariables: updatedVariables,
                isDirty: isDirty,
            } as ProcessVariablesEditorState);
        case ProcessVariableEditorActions.VALIDATE_PROCESS_VARIABLES:
            const validateProcessVariableValueAction = action as ProcessVariableEditorActions.ValidateProcessVariablesAction;

            const processVariables = state.processVariables.map(processVariable => {
                processVariable.validationErrors = validateProcessVariableValue(processVariable, validateProcessVariableValueAction.environmentVariables)
                return processVariable;
            });

            return Object.assign({}, state, {
                processVariables: processVariables,
            } as ProcessVariablesEditorState);
        default:
            return state;
    }
}

